module.exports = __webpack_public_path__ + "assets/0048c647249f8d3a64ca46f06b7f2df9.png";